/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine200,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine401,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine404,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLinePathParams,
  GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLineQueryResponse,
} from "../../types/classPlanningFeedbacksController/GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine.ts";
import { feedbackChartDataViewModelSchema } from "../feedbackChartDataViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLinePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    feedbackId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLinePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine200Schema =
  z.lazy(
    () => feedbackChartDataViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine404>;

export const getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLineQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLine200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdFeedbacksFeedbackidChartsLineQueryResponse>;
